<template>
  <div class="layout-view">
    <div class="layout" v-if="isShow">
      <Header />

      <main>
        <router-view />
      </main>

      <Footer />
    </div>
    <div class="invite-activity" v-else>
      <InviteActivity />
    </div>
  </div>
</template>
<script>
import Header from "@/components/Layout/header.vue";
import Footer from "@/components/Layout/footer.vue";
import InviteActivity from "./InviteActivity.vue";

export default {
  name: "layout",
  components: {
    Header,
    Footer,
    InviteActivity,
  },
  data() {
    return {
      isShow: true,
    };
  },
  created() {
    if (
      this.$route.query.InviteCode === undefined ||
      this.$route.query.InviteCode === ""
    )
      return;
    if (
      window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      this.isShow = false;
      let metaTag = document.createElement("meta");
      metaTag.name = "viewport";
      metaTag.content =
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0";
      document.getElementsByTagName("head")[0].appendChild(metaTag);
    } else {
      this.isShow = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.layout {
  background-color: #0c0c0c;
  min-width: 1480px;
  main {
    height: calc(100% - (48px + 40px));
  }
}
</style>
